import { useRouter } from 'next/router';

import { UNSUPPORTED_CHATBOT_LOCALES } from '../constants';
import { useStore } from '../zustand/stores';

const useIsSearchRedirectToContactEnabled = () => {
  const { user } = useStore((state) => state.userSlice);
  const { locale } = useRouter();

  if (!user || UNSUPPORTED_CHATBOT_LOCALES.includes(locale as string)) {
    return false;
  }

  return true;
};

export default useIsSearchRedirectToContactEnabled;
